import {registerAgent,upAgent,agentRecharge,agentList,batchDelAgent,editAgentPassword} from 'api/agent';
import Cookies from 'js-cookie';

const agent = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        registerAgent({commit},params) {
            return new Promise((resolve, reject) => {
                registerAgent(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        upAgent({commit},params) {
            return new Promise((resolve, reject) => {
                upAgent(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        agentRecharge({commit},params) {
            return new Promise((resolve, reject) => {
                agentRecharge(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        agentList({commit},params) {
            return new Promise((resolve, reject) => {
                agentList(params.account, params.remark, params.psize).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchDelAgent({commit},params) {
            return new Promise((resolve, reject) => {
                batchDelAgent(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        editAgentPassword({commit},params) {
            return new Promise((resolve, reject) => {
                editAgentPassword(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default agent;



// WEBPACK FOOTER //
// ./src/store/modules/agent.js